<input #fileUpload type="file" (change)="changeFile($event.target.files)" accept=".csv" single
    [disabled]="isDisabled" />